import { render, staticRenderFns } from "./Aerospace_together.vue?vue&type=template&id=23c05ea2&scoped=true"
import script from "./Aerospace_together.vue?vue&type=script&lang=js"
export * from "./Aerospace_together.vue?vue&type=script&lang=js"
import style0 from "./Aerospace_together.vue?vue&type=style&index=0&id=23c05ea2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23c05ea2",
  null
  
)

export default component.exports